export function getApiBaseUrl(): string {
  const v = (import.meta.env.VITE_API_BASE_URL ?? "").trim();
  if (!v) return "";
  return v.replace(/\/$/, "");
}
